module.exports = "data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAAAQAwCdASoZABkAPpFCnEolo6KiKAgAsBIJaQDO7BanFAAA/vZoKbxxXLTzC4q7PZG9wgAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/black.webp
// module id = uinV
// module chunks = 14